import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { ConfluenceIcon } from '@atlaskit/temp-nav-app-icons/confluence';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function confluence(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <ConfluenceIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		apsKey: Products.CONFLUENCE,
		fallbackUrl,
	};
}
